import { render, staticRenderFns } from "./PortalDashboardQuality.vue?vue&type=template&id=537f4363"
import script from "./PortalDashboardQuality.vue?vue&type=script&lang=js"
export * from "./PortalDashboardQuality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports